<template>
	<div class="bookcityBox">
			<div class="titleAble">
				<div class="titleAbleItem">
					<a href="#" v-for="(item,index) in titleAbles" :key="index" @click="firstValue(index)" :class="homeIndex == index ? 'active_tit' : ''"><span class="line" v-show="homeIndex == index"></span>{{item}}</a>
				</div>
			</div>
	</div>
</template>

<script>
	import { Toast } from 'vant';
	// import  firstSecondTabbarValue from '../../firstSecondTabbar.js';//引入兄弟组建公共js
	export default {
		props: ['swiperSendIndex'],
		data() {
			return {
				homeIndex: 0,
				activeIndexFirst: '',
				titleAbles:["首页","言情","纯爱","衍生","无CP"],
			}
		},
		watch: {
		  swiperSendIndex (value, oldvalue) {
			  console.log(value,'26????')
		    // 接收 swiper组件传过来的索引，导航高亮
		    this.homeIndex = value;
		  }
		},
		created() {
			
			if (this.$webapp.isAndroid) {
				console.log("安卓")
				let isdark = 1;
				this.range = window.android.setBarcolor(Boolean(isdark)); //获取亮度 --- 安卓
			} else if (this.$webapp.isiOS) {
				console.log("苹果")
				// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
			}
		},
		methods: {
			firstValue (txt){
				console.log(txt,'一级导航')
				this.homeIndex = txt;
				console.log(this.homeIndex,'this.homeIndex')
				this.$emit('firstValue',this.homeIndex);
				// 一级导航传值给兄弟组建
				// firstSecondTabbarValue.$emit('firstValue',txt)
			},
		}
	}
</script>
<style scoped="scoped" lang="less">
	.bookcityBox {
		background-color: #f0f0f0;
		// height: 100vh;
		// overflow-y: scroll;
		.titleAble {
			display: flex;
			height: 160px;
			// background: url(../../assets/img/yun.png) no-repeat 7% 60px;
			// background-size: 16%;
			// background-color: #ff4685;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			
			border-bottom: 1px solid #f0f0f0;/*no*/
			.titleAbleItem {
				margin-top: 80px;
				height: 80px;
				line-height: 80px;
				display: flex;
				justify-content: space-between;
				width: 100vw;
				padding: 0 16px;
				// background: url(../../assets/img/myicon/indexBgc.png);
				// background-size: 100%;
				a {
					text-align: center;
					display: inline-block;
					color: #000;
					font-size: 36px;/*px*/
					position: relative;
					.line {
						width:72px;height: 4px;
						background-color: #ff4081;
						display: block;
						position: absolute;
						bottom: 5px;
						border-radius: 2px;
					}
				}
				.active_tit {
					transform: scale(1.16);
					color: #ff4081;
				}
			}
		}
	}
</style>
		